module.exports = __webpack_public_path__ + "static/media/vapour-img2.54d5901e.png";